<template>
  <div class="no-authority x-flex-y x-flex-center">
    <img src="@/assets/images/web/404.png" alt="" />
    <el-button type="primary" size="small" @click="backHome">{{$t('HT.userList.gohome')}}</el-button>
  </div>
</template>

<script>
import { getLocalStorage } from '@l/localStorage.js';
export default {
  methods: {
    backHome() {
      let menu = getLocalStorage('userMenu');
      this.$router.push(menu[0] ? `/${menu[0]}` : '/login');
    }
  }
};
</script>

<style lang="scss" scoped>
.no-authority {
  box-sizing: border-box;
  height: 100%;
  padding-bottom: 200px;

  > img {
    width: 530px;
    height: auto;
  }

  .el-button {
    margin: 70px 0 0 105px;
  }
}
</style>
